import {Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, inject, viewChild} from '@angular/core';
import {ButtonModule} from 'primeng/button';
import {DialogModule} from 'primeng/dialog';
import {ResourcesService} from '../../services/resources.service';
import {ThemeCardComponent} from '../../components/theme-card/theme-card.component';
import {GameStore} from '../../store/game.store';

@Component({
  selector: 'gis-starting-screen',
  imports: [ButtonModule, DialogModule, ThemeCardComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './starting-screen.component.html',
  styleUrl: './starting-screen.component.scss'
})
export class StartingScreenComponent {
  protected readonly resourcesService = inject(ResourcesService);
  protected readonly store = inject(GameStore);

  readonly gmModal = viewChild<ElementRef>('gmModal');

  showInfo() {
    this.gmModal()?.nativeElement.show();
    this.store.setInfoModalOpen(true);
  }

  hideInfo() {
    this.store.setInfoModalOpen(false);
  }
}
